@if (loading) {
	<div class="text-center loading-overlay-spinner"><i class="fa fa-spinner fa-pulse fa-spin fa-3x"></i></div>
	<div class="overlay-container" [style.top]="'0px'" [style.left]="'0px'"></div>
}
<ng-content></ng-content>
